'use client';
import { PropsWithChildren } from 'react';
import { Chip, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

type Props = {};

const Tag = ({ children }: PropsWithChildren<Props>) => {
  if (!children) return null;
  return (
    <Chip
      sx={{
        py: 1,
        px: 1.5,
        borderRadius: 1,
        color: (theme) => theme.palette.text.primary,
      }}
      icon={<CircleIcon sx={{ fontSize: '5px' }} />}
      variant={'outlined'}
      label={
        <Typography variant={'body2'} component={'span'}>
          {children}
        </Typography>
      }
    />
  );
};

export default Tag;
